import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useProjects } from '../api/projects';
import { useMe } from '../api/auth';
import AddProjectModal from '../components/AddProjectModal';

export default function ProjectList() {
  const { data, isLoading, error } = useProjects();
  const me = useMe();
  const isAdmin = me.data?.role === 'admin';
  const [showAdd, setShowAdd] = useState(false);

  return (
    <div className="max-w-4xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">My Projects</h1>
        {isAdmin && (
          <div className="flex items-center gap-2">
            <button
              onClick={() => setShowAdd(true)}
              className="px-3 py-1.5 bg-emerald-600 text-white text-sm rounded hover:bg-emerald-700"
            >
              + Add Project
            </button>
            <Link
              to="/admin"
              className="px-3 py-1.5 bg-white text-slate-700 text-sm rounded border border-slate-300 hover:bg-slate-50"
            >
              Manage Users
            </Link>
          </div>
        )}
      </div>

      {isLoading && <div className="text-slate-500">Loading…</div>}
      {error && (
        <div className="rounded border border-red-300 bg-red-50 p-3 text-red-800 text-sm">
          {(error as Error).message}
        </div>
      )}

      {data && data.length === 0 && (
        <div className="rounded border border-dashed border-slate-300 p-12 text-center text-slate-500">
          {isAdmin ? (
            <>
              No projects yet. Click &quot;Add Project&quot; to connect a folder that has
              been initialized with <code className="font-mono text-slate-700">pipeline init</code>.
            </>
          ) : (
            <>
              No projects assigned to you yet. Ask an admin to add you to a project.
            </>
          )}
        </div>
      )}

      <ul className="space-y-2">
        {data?.map((p) => (
          <li key={p.id}>
            <Link
              to={`/p/${p.slug}`}
              className="block border border-slate-200 bg-white rounded p-4 hover:border-slate-400 transition"
            >
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-medium">{p.name}</div>
                  <div className="text-xs text-slate-500 font-mono">{p.slug}</div>
                </div>
                <div className="text-xs text-slate-500">{p.local_path}</div>
              </div>
              {p.description && (
                <div className="text-sm text-slate-600 mt-1">{p.description}</div>
              )}
            </Link>
          </li>
        ))}
      </ul>

      {showAdd && <AddProjectModal onClose={() => setShowAdd(false)} />}
    </div>
  );
}
